export default "__VITE_ASSET__BQPnwOg5__"